import Vue from 'vue'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import Element from 'element-ui'
import vueEsign from 'vue-esign'
import Toast from '@/utils/toast'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import * as filters from './filters' // global filters
import JsEncrypt from 'jsencrypt'
import Pagination from '@/components/Pagination'
// popup
import PopupView from '@/components/PopupView'

Vue.prototype.$jsEncrypt = JsEncrypt

Vue.use(Element, {
  size: 'mini' // set element-ui default size
})
Element.Dialog.props.closeOnClickModal.default = false
Element.Dialog.props.top.default = '20px'
// 处理IE浏览器遮罩层在Dialog上面
Element.Dialog.props.appendToBody.default = true

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.component('table-pagination', Pagination)
// 灰色背景、无标题无icon 弹框 使用方式：this.$toast('复制设备成功')
Vue.use(Toast)
Vue.use(vueEsign)
Vue.component('popup-view', PopupView)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
